export enum PatientsPopupType {
  Active = 1,
  Approved,
  Admitted,
  Discharged,
}

export default {};
